import axios from "axios";
import "./../assets/sass/_login.scss";
import "./../assets/sass/_review.scss";
import gif from "./../assets/img/spin.gif";
import InputComponent from "./InputComponent";
import { useNavigate } from "react-router-dom";
import ButtonComponent from "./ButtonComponent";
import React, { useState, useEffect } from "react";
import DropDownComponent from "./DropDownComponent";
import TableRowComponent from "./../Components/TableRowComponent";
import { API_Link, validateHeader } from "./../commons/Constants";

function AddReview() {
  const MD5hash = validateHeader();
  const [reviewType, setReviewTypeNew] = useState([]);
  const [studyId, setStudyId] = useState(localStorage.getItem("studyId"));
  const [selectValue, setSelectValue] = useState("");
  const [lookupOptions, setLookupOptions] = useState("");
  const [lookupOptions1, setLookupOptions1] = useState("");
  const [lookupOptions2, setLookupOptions2] = useState("");
  const [lookupOptions4, setLookupOptions4] = useState("");
  const [reviewList, setFilteredReview] = useState();
  const [server_message, setMessage] = useState(false);
  const [getDepartmentType, setGetDepartmentType] = useState([]);
  const [loader, setLoader] = useState(false);
  const [emailsList, setEmailsList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const handleDropdownToggle = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  const handleOptionSelect = (id) => {
    studyCheck(id); // Call the selection function
    setIsOpen(false); // Close dropdown after selection
  };
  const navigate = useNavigate();

  const studyCheck = (id) => {
    setSelectValue(id); // Update the selected value in state
    localStorage.setItem("studyId", id); // Save to localStorage
    setStudyId(id); // Update the state from localStorage (optional, since id is already set)
  };

  const getEmailListAPI = (newvalue) => {
    var config = {
      method: "get",
      url: `${API_Link}getEmailsList`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
      params: {
        keyword: newvalue,
      },
    };
    axios(config)
      .then(function (response) {
        const resData = response;

        setEmailsList(resData.data.emails);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getlookup = () => {
    var config = {
      method: "get",
      url: `${API_Link}getLookupsList?options=true&title=exclusion_purpose`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    axios(config)
      .then(function (response) {
        const resData = response;

        setReviewTypeNew(resData.data.lookups[0].options);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getReviewTypesApi = () => {
    var config = {
      method: "get",
      url: `${API_Link}getReviewTypes`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    axios(config)
      .then(function (response) {
        const resData = response;
        setGetDepartmentType(resData.data.reviewTypes);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const review_type_options = [
    {
      value: "",
      label: "Please Choose an Option",
    },
    {
      value: "2",
      label: "Health Technology Assessment (HTA)",
    },
    {
      value: "3",
      label: "Technology Review (TR)",
    },
    {
      value: "4",
      label: "Information Brief (IB)",
    },
    {
      value: "5",
      label: "Economic Evaluation (EE)",
    },
    {
      value: "6",
      label: "TechBrief",
    },
    {
      value: "7",
      label: "TechScan",
    },
    {
      value: "8",
      label: "Clinical Practice Guidelines (CPG)",
    },
    {
      value: "9",
      label: "Others",
    },
  ];
  //ist code start
  const cancelSVG = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 36 36"
    >
      <g id="Icon__minus" transform="translate(-1609 -435)">
        <circle
          id="Ellipse_29"
          data-name="Ellipse 29"
          cx="18"
          cy="18"
          r="18"
          transform="translate(1609 435)"
          fill="#ec4949"
        />
        <line
          id="Line_69"
          data-name="Line 69"
          x2="16"
          transform="translate(1619.5 453.5)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="4"
        />
      </g>
    </svg>
  );
  const addSVG = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 37 37"
    >
      <g id="icon__plus" transform="translate(-1773 -76)">
        <circle
          id="Ellipse_15"
          data-name="Ellipse 15"
          cx="18"
          cy="18"
          r="18"
          transform="translate(1773 76)"
          fill="#64c564"
        />
        <g
          id="Group_297"
          data-name="Group 297"
          transform="translate(1783.657 86.731)"
        >
          <line
            id="Line_50"
            data-name="Line 50"
            x2="16.368"
            transform="translate(0 8.499)"
            fill="none"
            stroke="#fff"
            strokeWidth="4"
          />
          <line
            id="Line_51"
            data-name="Line 51"
            y2="16.368"
            transform="translate(8.184)"
            fill="none"
            stroke="#fff"
            strokeWidth="4"
          />
        </g>
      </g>
    </svg>
  );

  function Delete(id) {
    setLookupOptions(
      lookupOptions && lookupOptions.filter((index) => index.id !== id)
    );
  }

  // Function For adding new row object
  function myFunction() {
    setLookupOptions([
      ...lookupOptions,
      {
        id: lookupOptions.length + 1,
        name: "",
        email: "",
      },
    ]);
  }

  //end for ist
  //2nd code start
  const cancelSVG1 = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 36 36"
    >
      <g id="Icon__minus" transform="translate(-1609 -435)">
        <circle
          id="Ellipse_29"
          data-name="Ellipse 29"
          cx="18"
          cy="18"
          r="18"
          transform="translate(1609 435)"
          fill="#ec4949"
        />
        <line
          id="Line_69"
          data-name="Line 69"
          x2="16"
          transform="translate(1619.5 453.5)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="4"
        />
      </g>
    </svg>
  );
  const addSVG1 = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 37 37"
    >
      <g id="icon__plus" transform="translate(-1773 -76)">
        <circle
          id="Ellipse_15"
          data-name="Ellipse 15"
          cx="18"
          cy="18"
          r="18"
          transform="translate(1773 76)"
          fill="#64c564"
        />
        <g
          id="Group_297"
          data-name="Group 297"
          transform="translate(1783.657 86.731)"
        >
          <line
            id="Line_50"
            data-name="Line 50"
            x2="16.368"
            transform="translate(0 8.499)"
            fill="none"
            stroke="#fff"
            strokeWidth="4"
          />
          <line
            id="Line_51"
            data-name="Line 51"
            y2="16.368"
            transform="translate(8.184)"
            fill="none"
            stroke="#fff"
            strokeWidth="4"
          />
        </g>
      </g>
    </svg>
  );

  function Delete1(id) {
    setLookupOptions1(
      lookupOptions1 && lookupOptions1.filter((index) => index.id !== id)
    );
  }

  // Function For adding new row object
  function myFunction1() {
    setLookupOptions1([
      ...lookupOptions1,
      {
        id: lookupOptions1.length + 1,
        name: "",
        email: "",
      },
    ]);
  }
  //end for 2nd
  //3rd code start
  const cancelSVG2 = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 36 36"
    >
      <g id="Icon__minus" transform="translate(-1609 -435)">
        <circle
          id="Ellipse_29"
          data-name="Ellipse 29"
          cx="18"
          cy="18"
          r="18"
          transform="translate(1609 435)"
          fill="#ec4949"
        />
        <line
          id="Line_69"
          data-name="Line 69"
          x2="16"
          transform="translate(1619.5 453.5)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="4"
        />
      </g>
    </svg>
  );
  const addSVG2 = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 37 37"
    >
      <g id="icon__plus" transform="translate(-1773 -76)">
        <circle
          id="Ellipse_15"
          data-name="Ellipse 15"
          cx="18"
          cy="18"
          r="18"
          transform="translate(1773 76)"
          fill="#64c564"
        />
        <g
          id="Group_297"
          data-name="Group 297"
          transform="translate(1783.657 86.731)"
        >
          <line
            id="Line_50"
            data-name="Line 50"
            x2="16.368"
            transform="translate(0 8.499)"
            fill="none"
            stroke="#fff"
            strokeWidth="4"
          />
          <line
            id="Line_51"
            data-name="Line 51"
            y2="16.368"
            transform="translate(8.184)"
            fill="none"
            stroke="#fff"
            strokeWidth="4"
          />
        </g>
      </g>
    </svg>
  );

  function Delete2(id) {
    setLookupOptions2(
      lookupOptions2 && lookupOptions2.filter((index) => index.id !== id)
    );
  }

  function Delete4(id) {
    setLookupOptions4(
      lookupOptions4 && lookupOptions4.filter((index) => index.id !== id)
    );
  }
  // Function For adding new row object
  function myFunction2() {
    setLookupOptions2([
      ...lookupOptions2,
      {
        id: lookupOptions2.length + 1,
        name: "",
        email: "",
      },
    ]);
  }

  function myFunction4() {
    setLookupOptions4([
      ...lookupOptions4,
      {
        id: lookupOptions4.length + 1,
        name: "",
        email: "",
      },
    ]);
  }

  function handleChangeForName(type, value) {
    setLookupOptions(
      lookupOptions.map((option) => {
        return option.id === type
          ? { ...option, name: value.target.value }
          : option;
      })
    );
  }
  function handleChangeForEmail(type, value) {
    let newvalue = value.target.value;
    setLookupOptions(
      lookupOptions.map((option) =>
        option.id === type ? { ...option, email: value.target.value } : option
      )
    );
    if (value.target.value.length > 2) {
      getEmailListAPI(newvalue);
    }
  }
  //
  function handleChangeForName1(type, value) {
    setLookupOptions1(
      lookupOptions1.map((option) => {
        return option.id === type
          ? { ...option, name: value.target.value }
          : option;
      })
    );
  }
  function handleChangeForEmail1(type, value) {
    let newvalue = value.target.value;
    setLookupOptions1(
      lookupOptions1.map((option) =>
        option.id === type ? { ...option, email: value.target.value } : option
      )
    );
    if (value.target.value.length > 2) {
      getEmailListAPI(newvalue);
    }
  }
  //
  function handleChangeForName2(type, value) {
    setLookupOptions2(
      lookupOptions2.map((option) => {
        return option.id === type
          ? { ...option, name: value.target.value }
          : option;
      })
    );
  }
  function handleChangeForEmail2(type, value) {
    let newvalue = value.target.value;
    setLookupOptions2(
      lookupOptions2.map((option) =>
        option.id === type ? { ...option, email: value.target.value } : option
      )
    );

    if (value.target.value.length > 2) {
      getEmailListAPI(newvalue);
    }
  }

  //
  function handleChangeForName4(type, value) {
    setLookupOptions4(
      lookupOptions4.map((option) => {
        return option.id === type
          ? { ...option, name: value.target.value }
          : option;
      })
    );
  }
  function handleChangeForEmail4(type, value) {
    let newvalue = value.target.value;
    setLookupOptions4(
      lookupOptions4.map((option) =>
        option.id === type ? { ...option, email: value.target.value } : option
      )
    );
    if (value.target.value.length > 2) {
      getEmailListAPI(newvalue);
    }
  }

  const [title, setTitle] = useState();
  const [review_type, setReviewType] = useState();
  const [tentative_completion_date, settentative_completion_date] = useState();

  function handleChange(type, value) {
    switch (type) {
      case "title":
        setTitle(value.target.value);
        break;
      case "review_type":
        setReviewType(value);
        break;
      case "tentative_completion_date":
        settentative_completion_date(value.target.value);
        break;
      default:
        break;
    }
  }

  const [is_followup, setStatus] = useState("0");
  function handleChangeForStatus(e) {
    setStatus(e.target.value);
  }
  //save review data
  const users = JSON.parse(localStorage.getItem("user"));

  const token = users.token;

  function addReview(data) {
    setLoader(true);
    axios
      .post(`${API_Link}addReview`, data, {
        headers: {
          "misr-auth": MD5hash,
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        res.data.status === 1 &&
          setMessage({
            code: 200,
            message: "Data Has been added successfully.",
          });

        //

        localStorage.removeItem("studyId");
        setLoader(false);
        localStorage.setItem("studyId", res.data.review_id);
        localStorage.setItem("pageId", 1101);
        navigate("/searchinginclusion");
        res.data.status === 0 &&
          setMessage({ code: 400, message: res.data.error_message });
      })
      .catch((error) => {
        alert(JSON.stringify(error.response.data.error_message));
        setLoader(false);
      });
  }
  function handleSubmit() {
    const screening_reviewers = [];
    if (lookupOptions.length > 0) {
      lookupOptions.forEach((lookup) => {
        screening_reviewers.push({
          name: lookup.name,
          email: lookup.email,
        });
      });
    }

    const fulltext_reviewers = [];
    if (lookupOptions1.length > 0) {
      lookupOptions1.forEach((lookup1) => {
        fulltext_reviewers.push({
          name: lookup1.name,
          email: lookup1.email,
        });
      });
    }

    const extraction_reviewers = [];
    if (lookupOptions2.length > 0) {
      lookupOptions2.forEach((lookup2) => {
        extraction_reviewers.push({
          name: lookup2.name,
          email: lookup2.email,
        });
      });
    }

    const searching_reviewers = [];
    if (lookupOptions4.length > 0) {
      lookupOptions4.forEach((lookup4) => {
        searching_reviewers.push({
          name: lookup4.name,
          email: lookup4.email,
        });
      });
    }

    let data = {
      title,
      tentative_completion_date,
      review_type,
      is_followup,
      screening_reviewers: screening_reviewers,
      fulltext_reviewers: fulltext_reviewers,
      extraction_reviewers: extraction_reviewers,
      searching_reviewers: searching_reviewers,
    };

    addReview(data);
  }
  useEffect(() => {
    getlookup();
    getReviewsList();
    getReviewTypesApi();
  }, []);

  const getReviewsList = () => {
    var config = {
      method: "get",
      url: `${API_Link}getReviewsList`,
      headers: {
        "misr-auth": MD5hash,
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then(function (response) {
        const reviewdata = JSON.stringify(response.data.reviews);
        //onsole.log('reviewdata', reviewdata);
        const valuesArray = JSON.parse(reviewdata);

        setFilteredReview(valuesArray);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  let date = new Date();
  var current_date =
    date.getFullYear() +
    "-" +
    "0" +
    (date.getMonth() + 1) +
    "-" +
    date.getDate();

  return (
    <div className="main-wrapper">
      <div className="content-wrapper">
        <div className="page--content ">
          {/* {loader && (
            
          )} */}

          {loader ? (
            <div className="preload">
              <img src={gif} alt="" />
            </div>
          ) : (
            <>
            <div className="row inclusion-sticky-title">
            <h2 className="page--heading">Add Review</h2>
            </div>
              

              <div className="form--body">
                <form className="input--form">
                  <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">
                      Review Name
                    </label>
                    <div className="col-sm-5">
                      <InputComponent
                        for={"title"}
                        type={"text"}
                        placeholder={""}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">
                      Review Type
                    </label>
                    <div className="col-sm-5">
                      <DropDownComponent
                        id={"review_type"}
                        options={review_type_options}
                        handleChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">
                      Tentative Date to complete
                    </label>
                    <div className="col-sm-5">
                      <InputComponent
                        minValue={current_date}
                        for={"tentative_completion_date"}
                        type={"date"}
                        placeholder={"DD/MM/YYYY"}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">
                      Update Previous Review
                    </label>
                    <div className="col-sm-6 custom--logo">
                      <div className="" onChange={handleChangeForStatus}>
                        <input
                          class="form-check-input me-1"
                          type="radio"
                          checked={is_followup === "1"}
                          name="is_followup1"
                          value="1"
                          id="inlineRadio1"
                        />
                        Yes
                        <input
                          class="form-check-input ms-3 me-1"
                          checked={is_followup === "0"}
                          type="radio"
                          name="is_followup1"
                          value="0"
                          id="inlineRadio2"
                        />
                        No
                      </div>
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">
                      Review List
                    </label>
                    <div className="col-sm-5 select-main-dev">
                      {is_followup === "1" ? (
                        <div className="custom-dropdown">
                          <button
                            className="dropdown-button"
                            onClick={(e) => handleDropdownToggle(e)}
                          >
                            {studyId
                              ? reviewList?.find((item) => item.id === studyId)
                                  ?.title
                                ? reviewList
                                    ?.find((item) => item.id === studyId)
                                    ?.title.split(" ")
                                    .slice(0, 8)
                                    .join(" ") +
                                  (reviewList
                                    ?.find((item) => item.id === studyId)
                                    ?.title.split(" ").length > 8
                                    ? "..."
                                    : "")
                                : "Select an option"
                              : "Select an option"}
                          </button>

                          {isOpen && (
                            <ul className="dropdown-options">
                              {reviewList?.map(({ title, id }) => {
                                const truncatedTitle =
                                  title.split(" ").slice(0, 5).join(" ") +
                                  (title.split(" ").length > 5 ? "..." : "");
                                return (
                                  <li
                                    key={id}
                                    className="dropdown-option"
                                    onClick={() => handleOptionSelect(id)}
                                  >
                                    {truncatedTitle}
                                  </li>
                                );
                              })}
                            </ul>
                          )}
                        </div>
                      ) : (
                        <select className="form-select" disabled></select>
                      )}
                    </div>
                  </div>

                  <div className="form--box--row">
                    <div className="col-sm-12">
                      <h1>Information Specialists for Data Searching</h1>
                      <div className="mb-3 row">
                        {lookupOptions4 &&
                          lookupOptions4.map((lookupOptions4, index) => (
                            <TableRowComponent
                              key={index}
                              cellData={[
                                {
                                  data: (
                                    <InputComponent
                                      type={"text"}
                                      placeholder={"Name"}
                                      for={lookupOptions4.id}
                                      value={lookupOptions4.name}
                                      onChange={handleChangeForName4}
                                    />
                                  ),
                                },
                                {
                                  data: (
                                    <InputComponent
                                      type={"email"}
                                      list="emailList"
                                      placeholder={"Email"}
                                      for={lookupOptions4.id}
                                      value={lookupOptions4.email}
                                      onChange={handleChangeForEmail4}
                                    />
                                  ),
                                },
                                {
                                  data: (
                                    <a
                                      onClick={() => Delete4(lookupOptions4.id)}
                                    >
                                      {cancelSVG}
                                    </a>
                                  ),
                                },
                              ]}
                            />
                          ))}
                        <TableRowComponent
                          cellData={[
                            {
                              data: "",
                            },
                            {
                              data: "",
                            },
                            {
                              data: <a onClick={myFunction4}>{addSVG}</a>,
                            },
                          ]}
                        />
                      </div>
                      <datalist id="emailList">
                        {emailsList &&
                          emailsList.map(({ email }) => {
                            return <option value={email} />;
                          })}
                      </datalist>
                    </div>
                  </div>
                  <div className="form--box--row">
                    <div className="col-sm-12">
                      <h1>Reviewers for Data Screening</h1>
                      <div className="mb-3 row">
                        {lookupOptions &&
                          lookupOptions.map((lookupOptions, index) => (
                            <TableRowComponent
                              key={index}
                              cellData={[
                                {
                                  data: (
                                    <InputComponent
                                      type={"text"}
                                      placeholder={"Name"}
                                      for={lookupOptions.id}
                                      value={lookupOptions.name}
                                      onChange={handleChangeForName}
                                    />
                                  ),
                                },
                                {
                                  data: (
                                    <InputComponent
                                      type={"email"}
                                      list="emailList"
                                      placeholder={"Email"}
                                      for={lookupOptions.id}
                                      value={lookupOptions.email}
                                      onChange={handleChangeForEmail}
                                    />
                                  ),
                                },
                                {
                                  data: (
                                    <a onClick={() => Delete(lookupOptions.id)}>
                                      {cancelSVG}
                                    </a>
                                  ),
                                },
                              ]}
                            />
                          ))}
                        <TableRowComponent
                          cellData={[
                            {
                              data: "",
                            },
                            {
                              data: "",
                            },
                            {
                              data: <a onClick={myFunction}>{addSVG}</a>,
                            },
                          ]}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form--box--row">
                    <div className="col-sm-12">
                      <h1>Reviewers for Full Text Review</h1>
                      <div className="mb-3 row">
                        {lookupOptions1 &&
                          lookupOptions1.map((lookupOptions1, index) => (
                            <TableRowComponent
                              key={index}
                              cellData={[
                                {
                                  data: (
                                    <InputComponent
                                      type={"text"}
                                      placeholder={"Name"}
                                      for={lookupOptions1.id}
                                      value={lookupOptions1.name}
                                      onChange={handleChangeForName1}
                                    />
                                  ),
                                },
                                {
                                  data: (
                                    <InputComponent
                                      type={"email"}
                                      list="emailList"
                                      placeholder={"Email"}
                                      for={lookupOptions1.id}
                                      value={lookupOptions1.email}
                                      onChange={handleChangeForEmail1}
                                    />
                                  ),
                                },
                                {
                                  data: (
                                    <a
                                      onClick={() => Delete1(lookupOptions1.id)}
                                    >
                                      {cancelSVG1}
                                    </a>
                                  ),
                                },
                              ]}
                            />
                          ))}
                        <TableRowComponent
                          cellData={[
                            {
                              data: "",
                            },
                            {
                              data: "",
                            },
                            {
                              data: <a onClick={myFunction1}>{addSVG1}</a>,
                            },
                          ]}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form--box--row">
                    <div className="col-sm-12">
                      <h1>Reviewers for Data Extraction</h1>
                      <div className="mb-3 row">
                        {lookupOptions2 &&
                          lookupOptions2.map((lookupOptions2, index) => (
                            <TableRowComponent
                              key={index}
                              cellData={[
                                {
                                  data: (
                                    <InputComponent
                                      type={"text"}
                                      placeholder={"Name"}
                                      for={lookupOptions2.id}
                                      value={lookupOptions2.name}
                                      onChange={handleChangeForName2}
                                    />
                                  ),
                                },
                                {
                                  data: (
                                    <InputComponent
                                      type={"email"}
                                      list="emailList"
                                      placeholder={"Email"}
                                      for={lookupOptions2.id}
                                      value={lookupOptions2.email}
                                      onChange={handleChangeForEmail2}
                                    />
                                  ),
                                },
                                {
                                  data: (
                                    <a
                                      onClick={() => Delete2(lookupOptions2.id)}
                                    >
                                      {cancelSVG2}
                                    </a>
                                  ),
                                },
                              ]}
                            />
                          ))}
                        <TableRowComponent
                          cellData={[
                            {
                              data: "",
                            },
                            {
                              data: "",
                            },
                            {
                              data: <a onClick={myFunction2}>{addSVG2}</a>,
                            },
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="text-end mt-3">
                    <a href="#" className="btn modal-primary-btn">
                      Reset
                    </a>
                    {/* <a  className="add-new--btn" type="submit">
                                <IoIosAdd/>Submit Review
                            </a> */}
                    <ButtonComponent
                      text={"Submit Review"}
                      handleSubmit={handleSubmit}
                    />
                    {/*<button type="submit" handleSubmit={handleSubmit}>Submit Review</button>*/}
                  </div>
                </form>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default AddReview;
